import Submit from '../../components/inputs/Submit'
import Warehouse from '../../components/Warehouse'

const FirstSlide = ({ nextPage }) => {
  return (
    <>
      <i className='icon icon--logo s24' />
      <div className='slide__title center'>
        <div className='--secFont'>Gratulacje!</div>
        <div>Wynająłeś swojego MAGa</div>
      </div>

      <div className='fireworks'>
        <div />
        <div />
      </div>

      <Warehouse showShadow />

      <div className='slide__desc'>
        <div>Przed Tobą ostatnia prosta,</div>
        <div>musisz teraz skonfigurować swój panel</div>
      </div>

      <Submit text='Zaczynamy' action={nextPage} />
    </>
  )
}

export default FirstSlide